import React from "react";
import AddPosition from "../component/sections/position/AddPosition";
import AddPositionIndependent from "../component/sections/position/AddPositionIndependent";
import EditPositionIndependent from "../component/sections/position/EditPositionIndependent";
import AllPosition from "../component/sections/position/AllPosition";
import EditPosition from "../component/sections/position/EditPosition";
import middleware from "./middlewares/middleware";
import AllPositionIndependent from "../component/sections/position/AllPositionIndependent";
import AddImageToPositionIndependent from "../component/sections/position/AddImageToPositionIndependent";
import ReportAllPositionInSitePublisher from "../component/sections/publisher/manage/ReportAllPositionInSitePublisher";

const pageRoutes = [
  {
    /* id => page in web site publisher id */
    path: "/manage/position/all/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPosition />,
        "AllPosition"
      );
    },
    exact: true,
  },
  {
    /* id => page in web site publisher id */
    path: "/manage/position/add/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddPosition />,
        "AddPosition"
      );
    },
    exact: true,
  },
  {
    /* id =>  position id */
    path: "/manage/position/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditPosition />,
        "EditPosition"
      );
    },
    exact: true,
  },
  {
    /* id => site publisher id */
    path: "/manage/position/all-independent/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPositionIndependent />,
        "AllPositionIndependent"
      );
    },
    exact: true,
  },
  {
    /* id => site publisher id */
    path: "/manage/position/add-independent/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddPositionIndependent />,
        "AddPositionIndependent"
      );
    },
    exact: true,
  },
  {
    /* id => site publisher id */
    path: "/manage/position/edit-independent/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditPositionIndependent />,
        "EditPositionIndependent"
      );
    },
    exact: true,
  },
  {
    /* id => site publisher id */
    path: "/manage/position/add-image-independent/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddImageToPositionIndependent />,
        "AddImageToPositionIndependent"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/report/all-positions-in-site-publisher",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ReportAllPositionInSitePublisher />,
        "ReportAllPositionInSitePublisher"
      );
    },
    exact: true,
  },
];

export default pageRoutes;
